import apolloProvider from '@/vue-apollo';
const apolloClient = apolloProvider.defaultClient;

import CmsGql from '@/store/graphql/queries/Cms.gql';

export default {
  fetchCms: base_url =>
    new Promise((resolve, reject) => {
      apolloClient
        .query({ query: CmsGql, variables: { base_url } })
        .then(({ data }) => resolve(data.CP_Cms))
        .catch(error => reject(error.message));
    }),
  addRouteHistory: route => {
    let history = JSON.parse(window.sessionStorage.getItem('history')) || [];
    const latestRoute = history?.[0] || null;
    if (latestRoute !== route.path) {
      history.unshift(route.path);
      window.sessionStorage.setItem('history', JSON.stringify(history));
    }
  },
  getRouteHistory: () => {
    return JSON.parse(window.sessionStorage.getItem('history')) || [];
  }
};
